// src/components/AccountSideNav/AccountSideNav.jsx
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './AccountSideNav.module.css'; // Will be created soon
import HamburgerIcon from '../../assets/icons/HamburgerIcon'; // Assuming this icon can be reused

const AccountSideNav = () => {
    const [isNavCollapsed, setIsNavCollapsed] = useState(false);

    const toggleNavCollapse = () => {
        setIsNavCollapsed(!isNavCollapsed);
    };

    return (
        <aside className={`${styles.accountSidebar} ${isNavCollapsed ? styles.accountSidebarCollapsed : ''}`}>
            <div className={styles.sidebarHeader}>
                <button
                    onClick={toggleNavCollapse}
                    className={styles.navToggleButton}
                    aria-label={isNavCollapsed ? "Show navigation" : "Hide navigation"}
                    aria-expanded={!isNavCollapsed}
                >
                    <HamburgerIcon color="var(--text-dark-muted)" /> {/* Or your preferred icon color */}
                </button>
            </div>

            {!isNavCollapsed && (
                <nav>
                    <ul>
                        <li>
                            <NavLink
                                to="/account/reservations"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Reservations
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/account/payments"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Payments
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/account/documentation"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Documentation
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/account/profile"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                                end // Use 'end' for the profile link if it's the index route for /account
                            >
                                Account Profile
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/account/history"
                                className={({ isActive }) => isActive ? styles.activeLink : styles.inactiveLink}
                            >
                                Account History
                            </NavLink>
                        </li>
                    </ul>
                </nav>
            )}
        </aside>
    );
};

export default AccountSideNav;